import React from "react";
import PropTypes from "prop-types";
import * as moment from 'moment';


// import Placeholder from "../../hoc/placeholder/Placeholder.hoc";

// IMPORT COMMONS 
import { FloatButton, InvertedButton } from "../../common/button/Button.common";
import VideoSlider from "../videoSlider/VideoSlider.component";
import { SemiCircleDetail } from "../../common/floatingImage/Circle.common";

// IMPORT LOGOS
import TwoDash from "../../../assets/icons/ECDC_twodash.svg";
// import DetailCardPlaceholder from "../../../assets/placeholder/DetailCardPlaceholder.svg"

// OVERLAPPED CARD INVERTED
const DetailCard = ({ title, highlightText, description, dateVisible, images }) => {

    if (title.indexOf(highlightText) < 0) {
        console.error("NO HIGHLIGHT PART");
    }

    let titleWithoutHighlight = title.slice(0, title.indexOf(highlightText));
    let titleWithHighlight = title.slice(title.indexOf(highlightText), title.length);

    return (
        <div className="detailcard-container">
            <div className="detailcard">
                <SemiCircleDetail />
                <div className="detailcard-header">
                    <div className="detailcard-header-title text-font-rumpel text-upper text-lg">
                        {titleWithoutHighlight} <span className="text-blue text-font-rumpel">{titleWithHighlight}</span>
                    </div>
                    {
                        dateVisible &&
                        <div className="detailcard-header-date">
                            <FloatButton title= {moment(dateVisible).format('MMM DD, YYYY')} highlightText={dateVisible.slice(0,3)} />
                        </div>
                    }

                </div>

                <div className="mt-5">
                    <InvertedButton title="DONATE&nbsp;NOW" onClick={() => window.open("https://utopiafound.kindful.com/?campaign=228328")}/>
                </div>

                {images && images.length > 0 && <VideoSlider sliderImages={images} />}
                <div className="detailcard-desc mt-4 text-black text-font-averta text-xthin">
                    {
                        description.split("\n").map(function (item, idx) {
                            return (
                                <span key={idx}>
                                    {item}
                                    <br />
                                </span>
                            )
                        })
                    }
                </div>
                <div className="detailcard-twodash">
                    <img alt="FLOATING TWO DASH" src={TwoDash} />
                </div>
            </div>
        </div>
    )
}

DetailCard.propTypes = {
    title: PropTypes.string.isRequired,
    highlightText: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    dateVisible: PropTypes.string,
    images: PropTypes.node,
};

DetailCard.defaultProps = {
    title: "Everything happen for a Reason - Laxmi Tamang",
    highlightText: "Laxmi Tamang",
    description: "Pushpa Basnet found her inspiration early in life. At the age of 21, while an undergraduate at St. Xavier College in Kathmandu, Pushpa visited a prison as part of her internship program. A 9-month old child, playing on the prison floor next to her mother, reached up and held onto the hem of her dress, and Pushpa experienced the overwhelming sense that “this girl called me up. This was not the place for her to be living.” From this moment, Pushpa began a courageous journey to help the innocent children living behind bars in Nepal. \n \n Pushpa, her sister, and a few friends quickly raised enough money to start a day care program for some of the children. Realizing this was not enough, Pushpa began to work with the incarcerated parent (primarily mothers), and the prison authorities, and gained their trust for the release of 2 children into her full time care. \n \n From these humble beginnings, Pushpa, her ECDC team and her supporters have provided housing, food, education, clothing, and medical care, to over 140 children of incarcerated parents in Nepal. More than this, together they have created a warm, loving family for the children in their care. \n \n Pushpa Basnet, called Mamu by the 40+ children currently living at the Butterfly Home, is determined to give these children their chance at a normal life, the opportunity to reach their potential. “These children have done nothing wrong. They are simply caught in something they do not understand… they deserve a better future. \n \n When a woman is incarcerated in Nepal and has no one able or willing to care for her children, she must choose between bringing her children to prison with her or sending them out to live on the streets by themselves, two unbearable options. \n \n Many mothers have chosen to keep their children with them in prison, considered ‘the lesser of the two evils. Unfortunately, children growing up in the confines of jail cells do not have access to education, proper nutrition, warm clothing, and medical care. And sadly, these children are highly vulnerable to various forms of abuses as well as the multiple negative effects on their physical, emotional, and psychological development.",
};

export default DetailCard;